import StudentTaskResult from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'studentId':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new StudentTaskResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/StudentTasks/StudentTaskResult/create.js